import React from "react";
import { inputWithError } from "../../HOC/inputWithError";
import { inputWithFloatingLabel } from "../../HOC/inputWithFloatingLabel";

import { inputWithStyle } from "../../HOC/inputWithStyle";
import InputBase from "../Inputs/InputBase";

export default function Calendar({
  value,
  setValue,
  label,
  disabled,
  type,
  validate,
}) {
  return (
    <Input
      label={label}
      type={type || "date"}
      value={value}
      onChange={setValue}
      id={label}
      style={{ height: "100%" }}
      disabled={disabled}
      validate={validate}
    />
  );
}

const Input = inputWithError(inputWithStyle(inputWithFloatingLabel(InputBase)));
